<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getBindFreight,
  readBindFreight,
  saveAudit,
  batchHandleAudit,
} from "@/api/user/client-freight";

import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { getAllClient } from "@/api/user/client";
import { getCountry } from "@/api/system/country";
export default {
  name: "clientFreight",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: getBindFreight,
        readBindFreight,
        saveAudit,
        getUser,
        getAllClient,
        batchHandleAudit,
      },
      config: {},
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              delete row.create_time;
              delete row.do_action;
              delete row.operator_name;
              this.$page.handleRequestMethods("saveAudit", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
            cancel() {
              this.isShow = true;
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { operator_name: 24 },
            { create_time: 24 },
            { do_action: 24 },
            { status: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("createTime"),
              key: "create_time",
              component: "Input",
              disabled: true,
              placeholder() {
                return this.$t("enter") + this.$t("createTime");
              },
            },
            {
              name: () => this.$t("operate"),
              key: "operator_name",
              component: "Input",
              disabled: true,
              placeholder() {
                return this.$t("enter") + this.$t("operate");
              },
            },
            {
              name: () => this.$t("operation"),
              key: "do_action",
              component: "Radio",
              options: [
                {
                  label: this.$t("unbind"),
                  value: "remove",
                  disabled() {
                    return true;
                  },
                },
                {
                  label: this.$t("bind"),
                  value: "add",
                  disabled() {
                    return true;
                  },
                },
              ],
              bind: { border: true },
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                {
                  label: this.$t("through"),
                  value: "YES",
                  disabled() {
                    return !this.$modal.isShow;
                  },
                },
                {
                  label: this.$t("not_through"),
                  value: "NO",
                  disabled() {
                    return !this.$modal.isShow;
                  },
                },
              ],
              default: "YES",
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              disabled() {
                return !this.$modal.isShow;
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
          footer: {
            show() {
              return this.isShow && this.$hasPermission(478);
            },
          },
        },
        batchAudit: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("batchHandleAudit", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ status: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                {
                  label: this.$t("through"),
                  value: "YES",
                },
                {
                  label: this.$t("not_through"),
                  value: "NO",
                },
              ],
              default: "YES",
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
          },

          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("batchAudit"),
              type: "audit",
              fnName: "audit",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "error",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            },
            audit() {
              let data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.getModal("batchAudit").open(data, function () {
                this.setTitle(this.$t("batchAudit"));
              });
            },
            unbind() {
              let data = {
                id: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("unbind"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("delBindFre", data).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: () => this.$t("clientName"),
          key: "account",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman_account",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("freightName"),
          key: "title",
          align: "left",
          minWidth: 300,
        },
        {
          name: () => this.$t("auditOrder") + this.$t("exlType"),
          minWidth: 80,
          render: (h, { row }) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type:
                      row.audit_status == 10
                        ? "error"
                        : row.audit_status == 0
                        ? "default"
                        : row.audit_status == 20
                        ? "warning"
                        : "primary",
                    size: "small",
                    disabled:
                      row.audit_status == 0 || !this.$hasPermission(479),
                  },
                  on: {
                    click: () => {
                      this.$refs["table"]
                        .handleRequestMethods("readBindFreight", row.id)
                        .then((res) => {
                          let data = {
                            id: row.id,
                            aid: res.payload.id,
                            do_action: res.payload.do_action,
                            operator_name: res.payload.operator_name,
                            create_time: res.payload.create_time,
                            status:
                              res.payload.status == 20
                                ? "YES"
                                : res.payload.status == 30
                                ? "NO"
                                : "",
                            remarks: res.payload.audit_msg,
                          };
                          this.$refs["table"]
                            .getModal("add")
                            .open(data, function () {
                              this.isShow =
                                res.payload.status == 10 ? true : false;
                              this.setTitle(
                                row.account + this.$t("auditOrder")
                              );
                            });
                        });
                      // row.remarks = "";
                      // this.$refs["table"]
                      //   .getModal("add")
                      //   .open(row, function () {
                      //     //     this.temp = row.audit_status == 30 ? false : true;
                      //     //     this.setTitle(
                      //     //       this.$t("auditOrder") + "(" + row.account + ")"
                      //     //     );
                      //   });
                    },
                  },
                },
                row.audit_status == 10
                  ? this.$t("wait") + this.$t("auditOrder")
                  : row.audit_status == 0
                  ? this.$t("normal")
                  : row.audit_status == 20
                  ? this.$tz("已通过")
                  : this.$t("not_through")
              ),
            ]);
          },
          // key: "audit_status",
          // component: "Button",
          // bind: {
          //   type: "error",
          //   size: "small"
          // },
          // disabled({ row }) {
          //   return row.audit_status == 0;
          // },
          // methods: {
          //   render({ value }) {
          //     return value == 0 ? "正常" : "待审核";
          //   },
          //   click({ row }) {
          //     this.$page
          //       .handleRequestMethods("readBindFreight", row.id)
          //       .then(res => {
          //         let data = {
          //           id: row.id,
          //           aid: res.payload.id,
          //           do_action: res.payload.do_action,
          //           operator_name: res.payload.operator_name,
          //           create_time: res.payload.create_time,
          //           status: "",
          //           remarks: ""
          //         };
          //         this.$page.getModal("add").open(data);
          //       });
          //   }
          // }
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          minWidth: 95,
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          minWidth: 95,
        },
        {
          name: () => this.$t("duty_rate"),
          key: "duty_rate",
          minWidth: 95,
        },
        {
          name: () => this.$t("paper_fee"),
          key: "paper_fee",
          minWidth: 110,
        },
        {
          name: () => this.$t("convert_rate"),
          key: "convert_rate",
          minWidth: 95,
        },
        {
          name: () => this.$t("express_currency"),
          key: "express_currency",
          minWidth: 95,
        },
        {
          name: () => this.$t("tax_currency"),
          key: "tax_currency",
          minWidth: 95,
        },
        {
          name: () => this.$t("method_code"),
          key: "transport_code",
          minWidth: 95,
        },
        {
          name: () => this.$t("callBack"),
          key: "callBack",
          minWidth: 95,
        },
      ],
    };
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "salesman_id")
        item.options = (
          await getUser({ standard: "Salesman" })
        ).data.payload.rows;
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "from_country")
        item.options = (
          await getCountry({ allow_depart: 1 })
        ).data.payload.rows;
      if (item.key === "to_country")
        item.options = (
          await getCountry({ allow_arrive: 1 })
        ).data.payload.rows;
    });
  },
};
</script>
